import { render, staticRenderFns } from "./EditAccessRight.vue?vue&type=template&id=68b01e8e"
import script from "./EditAccessRight.vue?vue&type=script&lang=js"
export * from "./EditAccessRight.vue?vue&type=script&lang=js"
import style0 from "./EditAccessRight.vue?vue&type=style&index=0&id=68b01e8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports